<template>
  <div v-if="colorOptions && colorOptions.length" class="list-product__colors">
    <div class="list-product__colors-container">
      <span
        v-for="color in colorOptions"
        :key="color.color"
        class="list-product__color"
        :style="`border: 1px solid ${
          selectedColor && selectedColor.case_device_id === color.case_device_id
            ? '#f37053'
            : '#d2d2d6'
        }; 
    width:22px; height:22px;`"
        @click.prevent="selectColor(color)"
      >
        <span
          class="list-product__color-circle"
          :style="`background-color:#${color.color};`"
        >
        </span>
      </span>
      <span
        v-if="productColorOptions.length > 4 && !showAllColors"
        class="list-product__color list-product__colors-more"
        style="width: 22px; height: 22px"
        @click.prevent="showAllColors = true"
        >+{{ productColorOptions.length - 4 }}</span
      >
      <span
        v-else-if="productColorOptions.length > 4 && showAllColors"
        class="list-product__color list-product__colors-more"
        style="width: 22px; height: 22px"
        @click.prevent="showAllColors = false"
      >
        -
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendationColorOption',
  props: {
    productColorOptions: {
      type: Array,
      default: () => [],
    },
    recommendedMaterial: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedMaterial: this.recommendedMaterial,
      selectedCaseDeviceId: null,
      showAllColors: false,
      selectedColor: {},
    }
  },
  computed: {
    colorOptions() {
      let opts = this.productColorOptions

      if (this.showAllColors) {
      } else if (opts?.length) {
        opts = opts?.slice(0, 4)
      }

      return opts || []
    },
  },
  watch: {
    selectedMaterial(value) {
      this.$emit('color-material-changed', value)
    },
    selectedCaseDeviceId(value) {
      this.$emit('color-case-device-changed', value)
    },
  },
  mounted() {
    this.setDefaultColor()
  },
  methods: {
    setDefaultColor() {
      const colorOptions = this.productColorOptions

      if (colorOptions?.length) {
        let defaultColor = colorOptions.find(
          (color) => color?.material === this.recommendedMaterial
        )
        defaultColor = defaultColor || colorOptions[0]
        this.selectColor(defaultColor)
      }
    },
    selectColor(color) {
      this.selectedColor = color
      this.selectedMaterial = color.material
      this.selectedCaseDeviceId = color.case_device_id

      this.$emit('color-option-changed')
    },
  },
}
</script>
